'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listItemBuilder = exports.collectionListBuilderDefault = exports.collectionListBuilder = exports.getItemDef = exports.getListDef = exports.entitySchema = undefined;

var _partial2 = require('lodash/partial');

var _partial3 = _interopRequireDefault(_partial2);

var _now2 = require('lodash/now');

var _now3 = _interopRequireDefault(_now2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _flow2 = require('lodash/flow');

var _flow3 = _interopRequireDefault(_flow2);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _refs, _entitySchema;

exports.getDefault = getDefault;
exports.collectionList = collectionList;
exports.collectionItem = collectionItem;

var _capeSelect = require('cape-select');

var _capeReduxAuth = require('cape-redux-auth');

var _const = require('./const');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var entitySchema = exports.entitySchema = (_entitySchema = {}, _defineProperty(_entitySchema, _const.COLLECTION_TYPE, {
  additionalType: true,
  dateCreated: true,
  itemListOrder: {
    default: _const.ASC
  },
  numberOfItems: {
    calc: true
  },
  title: {
    default: _const.FAV_TITLE
  },
  _refs: (_refs = {
    agent: true,
    creator: true,
    editor: true
  }, _defineProperty(_refs, _const.PREDICATE, {
    multi: true
  }), _defineProperty(_refs, 'mainEntity', true), _refs)
}), _defineProperty(_entitySchema, _const.LIST_ITEM, {
  actionStatus: {
    default: _const.CREATED
  },
  dateCreated: true,
  description: true,
  position: {
    default: 100
  },
  title: true,
  _refs: {
    creator: true,
    editor: true,
    item: true,
    mainEntity: true
  }
}), _entitySchema);

function getDefault(type, field) {
  return (0, _get3.default)(entitySchema, [type, field, 'default'], null);
}

var getListDef = exports.getListDef = (0, _partial3.default)(getDefault, _const.COLLECTION_TYPE);
var getItemDef = exports.getItemDef = (0, _partial3.default)(getDefault, _const.LIST_ITEM); // Merge in default Collection fields.

function collectionList() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _extends({
    creator: _capeReduxAuth.selectUser,
    // User that created the thing.
    editor: _capeReduxAuth.selectUser,
    // User that edits/owns has permission the thing.
    dateCreated: (0, _now3.default)(),
    itemListOrder: getListDef('itemListOrder'),
    title: getListDef('title')
  }, props, {
    type: _const.COLLECTION_TYPE
  });
} // Creates a structuredSelector that will create a new list.


var collectionListBuilder = exports.collectionListBuilder = (0, _flow3.default)(collectionList, _capeSelect.structuredSelector); // Default structuredSelector to build list.

var collectionListBuilderDefault = exports.collectionListBuilderDefault = collectionListBuilder();

function collectionItem(props) {
  if (!props.item) throw new Error('Creating a new collectionItem requires an `item`.');
  if (!props.mainEntity) throw new Error('`mainEntity` required to define item collection.');
  return _extends({
    actionStatus: getItemDef('actionStatus'),
    creator: _capeReduxAuth.selectUser,
    // User that created the thing.
    editor: _capeReduxAuth.selectUser,
    // User that edits/owns has permission the thing.
    startTime: (0, _now3.default)(),
    type: _const.LIST_ITEM,
    position: getItemDef('position')
  }, props);
} // Creates a structuredSelector that will create a new list.


var listItemBuilder = exports.listItemBuilder = (0, _flow3.default)(collectionItem, _capeSelect.structuredSelector);